export enum CheckoutSessionDetailAction {
  EDIT_CART = 'EDIT_CART',
  EDIT_DOWN_PAYMENT = 'EDIT_DOWN_PAYMENT',
  CANCEL_CHECKOUT_SESSION = 'cancel_checkout_session',
  SHARE = 'SHARE',
  SEE_DISTRIBUTIONS = 'SEE_DISTRIBUTIONS',
}
